import { AppThunk } from 'store';
import { setConnecting, setLoading } from 'features/audio/audioSlice';

let abortController = new AbortController();
let fetchAudioTimeout: NodeJS.Timeout;

const fetchAudioUrl = async (
  src: string,
  audioType: string,
  setSrc: (_: string) => void,
  retries = 0
) => {
  if (audioType === 'recording') {
    const results = await fetch(src, { method: 'GET' });
    if (results?.status === 200) {
      setSrc(src);
    }
  } else {
    // Cancel any pending fetches
    if (abortController) abortController.abort();
    abortController = new AbortController();
    const signal = abortController.signal;

    try {
      const results = await fetch(src, { method: 'GET', signal });

      // Retry every 6 seconds for 5 minutes.
      if (results?.status !== 200 && retries < 50) {
        fetchAudioTimeout = setTimeout(() => {
          console.log('[Audio] - Fetching audio: ', src);
          fetchAudioUrl(src, audioType, setSrc, retries + 1);
        }, 6000);
      } else {
        fetchAudioAbort();
        setSrc(src);
      }
    } catch (err) {
      if (err.name == 'AbortError') {
        console.log('[Audio] - Abort Error');
      } else {
        throw err;
      }
    }
  }
};

const delay = (delayInms: number) => {
  return new Promise((resolve) => setTimeout(resolve, delayInms));
};

export const fetchAudioAbort = () => {
  if (abortController.signal && abortController.signal.aborted) {
    return;
  }
  console.log('[Audio] - fetchAudioAbort');
  clearInterval(fetchAudioTimeout);
  abortController.abort();
};

export const checkAndPlayAudio =
  (
    src: string,
    audioType: string,
    setSrc: (_: string) => void,
    withDelay?: boolean
  ): AppThunk =>
  async (dispatch) => {
    dispatch(setLoading(true));
    dispatch(setConnecting(true));
    await delay(withDelay ? 2000 : 0);
    await fetchAudioUrl(src, audioType, setSrc);
  };
